import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const breadcrumbLabels: { [key: string]: string } = {
    dashboard: 'Личный кабинет',
    orders: 'Заказы',
    'order-history': 'История заказов',
    profile: 'Профиль',
    business: 'Бизнес профиль',
    personal: 'Личный профиль',
    tariffs: 'Тарифы',
    payment: 'Оплата',
    warehouse: 'Адрес склада',
    support: 'Поддержка'
  };

  return (
    <nav className="flex items-center space-x-2 text-sm text-gray-500">
      <Link to="/dashboard" className="hover:text-[#0171E3] transition-colors">
        Главная
      </Link>
      {pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;
        const label = breadcrumbLabels[name] || name;

        return (
          <React.Fragment key={name}>
            <ChevronRight className="w-4 h-4" />
            {isLast ? (
              <span className="text-gray-900 font-medium">{label}</span>
            ) : (
              <Link
                to={routeTo}
                className="hover:text-[#0171E3] transition-colors"
              >
                {label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

export default Breadcrumbs;